<template>
    <div id="customLP">
        <div id="googleAI" class="lpContainer landingBg text landing-body">
            <img class="headerCloudLeft" src="../../assets/landing/googleAI25/cloud.svg" />
            <img class="headerStars" src="../../assets/landing/googleAI25/stars.svg" />

            <div class="logosHeader">
                <img class="selaLogo" src="@/assets/footer logo.svg" alt="Sela" />
                <img src="../../assets/landing/googleAI25/googleCloud.svg" class="googleCloud" alt="Google" />
            </div>

            <div class="headerContainer">

                <div class="headerTitleContainer">
                    <div class="lpHeader">
                        Seriously?<br />
                        <span class="blueTitle">AI again?</span>
                    </div>
                    <span class="headerText">
                        Join us for a unique dinner and stand-up comedy event, designed for tech leaders.
                    </span>
                    <span class="headerDate">
                        16.12.2025&nbsp; |&nbsp; 18:00&nbsp; |&nbsp; TLV
                    </span>
                    <div class="regButton">
                        <button @click="$router.push('#contactFormAnc')" class="button thinButton">
                            Register Now
                        </button>
                    </div>
                </div>
                <img class="robotDrinks" src="../../assets/landing/googleAI25/robotDrinks.svg" />
                <img class="robotDrinksMobile" src="../../assets/landing/googleAI25/robotDrinksMobile.svg" />

            </div>



            <div class="panesContainer">
                <!-- ignore the left/right names... it's swapped-->
                <div class="agendaRightPane">

                </div>
                <div class="leftPane">
                    <div class="agendaContainer">
                        <span class="subTitle">Agenda</span>
                        <span class="agenda">

                            <strong>18:00&nbsp;&nbsp;|&nbsp;&nbsp;Wine, Dine & Connect</strong>
                            <br />Meet tech leaders, founders, and executives from Israel's fastest-growing companies.
                            <br /><br /><strong>19:30&nbsp;&nbsp;|&nbsp;&nbsp;Welcome and Opening Notes</strong>
                            <br /><span class="blueText">Ron Sprinzak, CEO, Sela</span>
                            <br /><br /><strong>19:40&nbsp;&nbsp;|&nbsp;&nbsp;Decoding Tomorrow: AI on the Frontier</strong>
                            <br /><span class="blueText">Shai Alon, Startup Evangelist, Google Cloud</span>
                            <br />Get the unfiltered view: latest proprietary AI updates
                            <br /><br /><strong>20:00&nbsp;&nbsp;|&nbsp;&nbsp;Stand-up by <span class="blueText">Eran
                                    Zaracovitz</span></strong>
                            <br />Get a break from AI agents and enjoy a standup comedy show by a real - not AI
                            generated- comedian.

                        </span>
                    </div>
                </div>

            </div>

            <div class="specialContainer">
                <div class="specialLeft">
                    <div class="specialSpeakerContainer">
                        <div class="specialSpeakerText">
                            <img class="stars" src="../../assets/landing/googleAI25/stars.svg" />
                            <div class="speakerTitle">Special Speaker: </div>
                            <div class="speakerName">Eran Zaracovitz</div>
                            <div class="speakerText">Eran Zaracovitz is a prominent Israeli comedian, actor, and
                                screenwriter, best known as one of the leading stars of Eretz Nehederet, HaParlament,
                                and the popular radio show Teicher & Zarhovich.</div>
                        </div>

                    </div>


                </div>
                <div class="specialRight">
                </div>
            </div>


            <div class="formContainer">
                <div class="formLeft" id="contactFormAnc">
                    <img class="robotFlies" src="../../assets/landing/googleAI25/robotFlies.svg" />
                    <img class="formCloudLeft" src="../../assets/landing/googleAI25/cloud.svg" />
                    <img class="robotFliesMobile" src="../../assets/landing/googleAI25/robotFliesMobile.svg" />
                    <img class="formStarsMobile" src="../../assets/landing/googleAI25/stars.svg" />
                    <span class="invited">You Are Invited</span>
                    <br /><span class="subTitle">Join us for an <br />exclusive evening</span>
                </div>
                <div class="formRight">


                    <div>
                        <!-- <div v-if="formStatus != 'success'" class="land-form-title">Fill in the form to download the
                            {{ lp.descriptionOfTheFile || "guide" }}</div> -->
                        <form class="form land-form-wrap" @submit.prevent="sendForm" v-if="formStatus != 'success'"
                            ref="contactForm" id="contactForm">
                            <input-field class="input land-input aiInputField" label="Full Name" :required="true"
                                v-model="form.fullName" @error-message="onError"
                                :validationType="ValidationTypeEnum.AlphaBet"
                                errorText="First name can only contain letters" />
                            <input-field class="input land-input aiInputField" type="email" label="Work Email"
                                :required="true" v-model="form.email" @error-message="onError"
                                :validationType="ValidationTypeEnum.Email" errorText="Invalid Email address" />
                            <input-field class="input land-input aiInputField" label="Phone Number" :required="true"
                                v-model="form.phone" @error-message="onError" :validationType="ValidationTypeEnum.Phone"
                                errorText="Invalid phone number" />
                            <input-field class="input land-input aiInputField" label="Company Name" :required="true"
                                v-model="form.company" @error-message="onError"
                                :validationType="ValidationTypeEnum.Required" errorText="Company is required" />
                            <select class="aiInputField" style="display:none" name="region" id="region"
                                v-model="form.region">
                                <option :value="null" disabled>Geographic Region</option>
                                <option v-for="region in $local.websiteSettings.region" :key="region._id"
                                    :value="region.name">
                                    {{ region.name }}</option>
                            </select>

                            <label class="bgl-checkbox-label">
                                <input @error-message="onError" errorText="You have to agree to the privacy policy"
                                    type="checkbox" class="bgl-checkbox" :required="true" v-model="checkboxChecked" />
                                <span class="checkbox">✔</span>
                                <span class="land-checkbox-txt">
                                    I have read and agree to the <a href="https://selacloud.com/legal/privacy-policy"
                                        target="_blank">Privacy Policy</a></span>
                            </label>
                            <button :disabled="formStatus === 'sending' || this.hasFalseProp || !checkboxChecked"
                                type="submit" class="button whiteBorderButton fullWidthButton">
                                Register Now
                            </button>
                            <span style="font-weight:100; text-align: left;">
                                <span style="font-weight: 400;"><br />STU-Concept Urban TLV - <br/>Events & Conference Venue</span>
                                <br />📍 24 Raoul Wallenberg St, Tel Aviv
                                <br />🅿️ Parking: Ziv Towers Parking Lot
                                <br/>* Complementary parking stickers will be available for our guests
                            </span>

                            <div class="error" v-if="formStatus == 'fail'">
                                <p>An error occurred while submitting the form</p>
                            </div>
                        </form>
                        <div class="thanks" v-if="formStatus == 'success'">
                            <!-- show a customized thank you text. if it includes @FILE_URL@ then replace it with the URL of the PDF-->
                            <div v-if="lp.formThankyouContent && lp.formThankyouContent != ''"
                                v-html="replaceUrlInThankyouText(lp.formThankyouContent)" />

                            <p v-else> <!-- show a default thank you text-->
                                <span class="new-line">Thank you for your interest in this event.
                                    As this event is on an invite-only basis, your registration is currently pending
                                    review. <br>Once approved, you will be informed.</span>
                            </p>
                        </div>
                    </div>


                </div>
            </div>
            <div class="bottomImage">

            </div>
        </div>




        <SocialMenu pagename="landing" :phoneForWhatsapp="lp.phoneForWhatsapp" whatsappOnly="true" :vendor="``"
            :title="`landing`" :color="'white'" :size="20" class="whatsapp-only social-menu small" />

        <botfooter v-if="!lp.footer"></botfooter>


    </div>
</template>


<script>
import Botfooter from "@/components/Botfooter.vue";
import axios from 'axios';
import SocialMenu from "../../components/SocialMenu.vue";

export default {
    metaInfo() {
        return {
            ssrAppId: "sela",
            ...this.seo({
                title: this.lp.title,
                description: this.lp.blurb,
                image: this.event?.thumbnail?.imageURL || this.lp.cover?.imageURL,
            }),
        };
    },
    components: {
        Botfooter,
        SocialMenu
    },
    data: () => ({
        now: new Date(),
        formStatus: "",
        form: {
            pageName: "",
            pageId: "",
            fullName: "",
            email: "",
            company: "",
            phone: "",
            jobTitle: "",
            region: null
        },
        checkboxChecked: false,
        ValidationTypeEnum: {
            AlphaBet: /^[a-zA-Z ]+$/,
            Email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
            Phone: /^(\+)?(?:[0-9-()/.\s?]){6,15}[0-9]{1}$/,
            Required: /.+/
        },
        hasFalseProp: false,
        formErrors: {},
    }),

    watch: {

    },
    computed: {
        lp() {
            // ******************** don't forget to change this ******************************************************
            const slug = "ai-2025";
            const lp = this.$local.landingPages?.find((c) => c.slug == slug);

            return lp
        },
    },
    mounted() {
        console.log("ver 15.59");
    },
    methods: {
        onError(errorObj) {
            this.formErrors[errorObj.label] = errorObj.validation;

            this.setFalseProp();
        },
        async sendForm() {
            try {
                this.setFalseProp();
                if (this.hasFalseProp) {
                    return; // Stop the form submission if there are errors
                }
                this.formStatus = "sending";
                this.form.pageName = this.lp.name;
                this.form.pageId = this.lp._id;

                // **************** NOTE: Selagroup instead of selacloud **********************
                await axios.post(
                    'https://selagroup.com/.netlify/functions/submitLandingDetails',
                    this.form
                );
                this.formStatus = "success";
            } catch (err) {
                console.log(err.response.data);
                this.formStatus = "fail";
            }
        },
        setFalseProp() {
            this.hasFalseProp = Object.values(this.formErrors).includes(false);
        },
        replaceUrlInThankyouText(htmlContent) {
            htmlContent = htmlContent.replace(/@FILE_URL@/g, this.lp.pDFForDownload.imageURL);
            console.log(htmlContent);
            return htmlContent;
        }
    },
    name: "Landing",
};

</script>

<style scoped>
#customLP {
    --landing-light-blue: #00DBE8;
    --container-border: #8f8f8f;
    padding-top: 30px;
    overflow: hidden;
}

.logosHeader {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 60px;
}

.selaLogo {
    width: 70px;
}

.blueTitle {
    font-weight: 600;
    color: var(--landing-light-blue);
}

#customLP .landingBg {
    background-color: black;
}

#customLP #googleAI.lpContainer {
    border-radius: 17px;
    border: 1px solid var(--container-border);
    position: relative;
}

.headerCloudLeft {
    position: absolute;
    top: 102px;
    left: -50px;
}

.headerStars,
.robotDrinksMobile,
.robotFliesMobile,
.formCloudLeft,
.formStarsMobile {
    display: none;
}

#customLP .button {
    background-color: rgb(255, 255, 255);
    color: black;
}

#customLP .button:disabled {
    background-color: rgb(119, 119, 119);
    border: 1px solid rgb(119, 119, 119);
    color: rgb(0, 0, 0);
}

#customLP .whiteBorderButton {
    font-weight: 500;
}

#customLP .button::after {
    content: url('../../assets/landing/google-otc/arrow-right.svg');
    width: 16px;
    height: 16px;
    top: 3px;
    position: relative;
    display: inline-block;
}

#customLP .bgl-checkbox:checked+.checkbox {
    color: white;
}

#customLP .agendaRightPane {
    background-image: url('../../assets/landing/googleAI25/salmon.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    border-right: 1px solid var(--container-border);
}

#customLP .panesContainer,
#customLP .specialContainer {
    border-bottom: 1px solid var(--container-border);
}

#customLP .panesContainer {
    border-top: 1px solid var(--container-border);
}

#customLP .bottomImage {
    border-top: 1px solid var(--container-border);
}

#customLP .land-form-wrap,
#customLP .thanks {
    max-width: 388px;
    width: 388px
}

#customLP .lpHeader {
    font-weight: 100;
}

#customLP .headerTitleContainer {
    font-size: 24px;
}

#customLP .specialRight {
    width: 311px;
    background-image: url(../../assets/landing/googleAI25/eranZar.jpg);
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: top;
}

#customLP .formContainer {
    width: 100%;
    justify-content: center;
    gap: 10%;
}


.robotDrinks {
    position: absolute;
    top: -35px;
    right: -234px;
}


.formLeft {
    position: relative
}

.robotFlies {
    position: absolute;
    top: -107px;
    left: -231px;
    width: 395px;
    max-width: 500px;
}

#customLP .leftPane,
#customLP .specialLeft {
    border: 0;
    flex: 70%;
}

#customLP .headerContainer {
    position: relative;
}

#customLP .headerContainer,
.logosHeader {
    justify-content: space-between;
    max-width: 85%;
}

#customLP .lpContainer .speaker,
#customLP .lpContainer .invited,
#customLP .lpContainer .speakerTitle {
    color: var(--landing-light-blue);
}

#customLP .lpContainer {
    padding-top: 75px;
}

.headerDate {
    font-size: 40px;
    margin-bottom: 40px;
    margin-top: 20px;
}

.blueText {
    color: var(--landing-light-blue);
}

#customLP .specialSpeakerContainer {
    background-color: unset;
}

#customLP .lpContainer .speakerName,
#customLP .lpContainer .speakerText {
    color: white
}

#customLP .bottomImage {
    background-image: url(../../assets/landing/googleAI25/googleRestaurant.jpg);
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 520px;
    width: 100%;
    border-bottom-left-radius: 17px;
    border-bottom-right-radius: 17px;
}

#customLP .specialSpeakerText {
    max-width: 100%;
    position: relative;
}

.stars {
    position: absolute;
    top: 35px;
    left: 260px;
}

#customLP .subTitle {
    font-size: 46px;
}

.land-form-thanks {
    max-width: 90%;
    margin: auto;
    background: transparent;
    color: white;
    margin-top: 100px;
}

#customLP .formLeft,
#customLP .formRight {
    flex: none;
}

#customLP .formLeft {
    padding-left: 0;
}

#customLP .formRight {
    margin: unset
}

::v-deep .landing-body h1 {
    font-weight: 300;
}

::v-deep .landing-sections {
    display: flex;
    gap: 70px;
    flex-wrap: wrap;
    justify-content: center;
}

::v-deep .landing-item img {
    max-width: 100px;
    max-height: 75px;
    object-fit: contain;
}

::v-deep .landing-sections>div.landing-item {
    flex: 0 0 25%;
    gap: 18px;
}

::v-deep .landing-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

::v-deep .footer-ad {
    margin-top: 100px;
    display: flex;
    max-width: 1170px;
    border: var(--linewidth) solid var(--light-blue);
    padding: 50px;
    text-align: left;
    gap: 50px;
    align-items: center;
}

::v-deep .footer-ad img {
    max-width: 30%;
}

#requestdemo {
    max-width: 1000px;
    height: 1000px;
    margin: auto;
}

.tech-top-wrap {
    margin-bottom: 120px;
}

.tech-bottom-img {
    margin: 60px -80px 60px 0;
    position: relative;
    z-index: 2;
    flex-basis: 46%;
}

#requestdemo {
    scroll-margin-top: 100px;
}



.tech-bottom-wrap {
    justify-content: space-around;
    margin-top: 100px;
}

.video {
    margin-right: 34px;
}

.video-shadow {
    box-shadow: rgb(0, 219, 232) 25px 25px;
    width: 675px;
}


.demo-title {
    display: flex;
    margin: auto;
    margin-top: 20px;
    gap: 20px;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

.button-container input {
    height: 54px;
    margin: 15px;
}

.demo-title img {
    max-width: 120px;
}

.main-container {
    display: flex;
    flex-direction: column;
}

.mobile-only {
    display: none;
}

.desktop-only {
    display: block;
}


@media screen and (max-width: 1300px) {

    .robotDrinks {
        width: 66%;
    }
}

@media screen and (max-width: 1200px) {

    #customLP .lpHeader,
    #customLP .lpSubtitle,
    #customLP .headerText,
    #customLP .regButton {
        padding-left: 0;
        padding-right: 0;
    }
}

@media screen and (max-width: 991px) {

    #customLP .subTitle {
        font-size: 36px;
    }

    #customLP .specialRight {
        min-height: 500px;
        width: 100%;
    }

    #contactForm {
        margin: auto;
    }

    #customLP .formLeft {
        max-width: 388px;
        margin: auto;
    }

    #customLP .formRight {
        padding-bottom: 70px;
    }

    .robotFlies {
        display: none;
    }

    #customLP .lpContainer {
        padding-top: 55px;
    }

    #customLP .button {
        height: 43px;
    }

    #customLP .regButton {
        margin-top: 0;
    }
}


@media screen and (max-width: 767px) {
    #customLP .headerText {
        font-size: 24px;
    }

    .headerCloudLeft,
    .robotDrinks {
        display: none;
    }

    .headerDate {
        font-size: 26px;
        /* padding-left: 15px; */
    }

    .headerStars {
        position: absolute;
        top: 106px;
        right: 29px;
        width: 41px;
        display: block;
    }

    .robotDrinksMobile {
        position: absolute;
        bottom: -72px;
        right: -87px;
        display: block;
        width: 500px;
        max-width: 500px;
    }

    .robotFliesMobile {
        position: absolute;
        top: -28px;
        right: -52px;
        display: block;
    }

    .formCloudLeft {
        position: absolute;
        top: 18px;
        left: -62px;
        width: 133px;
        display: block;
    }

    .formStarsMobile {
        position: absolute;
        top: 41px;
        right: 125px;
        width: 40px;
        display: block;
    }

    #customLP .headerContainer {
        padding-bottom: 200px;
    }

    #customLP .formLeft {
        padding-top: 160px;
    }

    ::v-deep .landing-sections>div.landing-item {
        flex: 0 0 100%;
    }

    ::v-deep .footer-ad {
        flex-direction: column;
        padding: 35px;
    }

    ::v-deep .footer-ad img {
        max-width: 100%;
    }

}

@media screen and (max-width: 479px) {

    .tech-top-frame.light-blue-line {
        border: 0;
    }

    .mobile-title {
        margin: 20px auto;
        border: 10px solid var(--light-blue);
        padding: 14px;
        width: 90;
        text-align: center;
    }

    .tech-top-frame {
        transform: translateY(0);
    }

    .tech-top-wrap {
        margin-bottom: 50px;
    }

    .tech-top-img {
        margin: 40px auto;
        flex-basis: 90%;
    }

    .tech-top-img img {
        object-fit: cover;
        width: 100%;
    }

    .mobile-only {
        display: block;
    }

    .desktop-only {
        display: none;
    }

    .tech-top-frame {
        text-align: center;
    }

    .tech-bottom-wrap {
        margin-top: 20px;
    }


    #customLP .formLeft {
        max-width: 500px;
        margin: unset;
    }

    #customLP .formContainer {
        width: 86%;
    }

    #customLP .land-form-wrap,
    #customLP .thanks {
        width: 100%;
    }

    ::v-deep .btn {
        padding: 12px 22px;
    }
}

@media screen and (max-width: 1200px) {
    .tech-bottom-img {
        margin: 60px auto 60px auto;
        text-align: center;
    }

    .landing-body {
        max-width: 90%;
    }
}
</style>